import { ReactElement } from 'react';
import styles from './FindSpecialistBtn.module.scss';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../../../app/module/lib/hooks/useAuthContext';
import { RoutePath } from '../../../config/routes';
import { IFindSpecialistBtnProps } from '../interfaces/IFindSpecialistBtn';
import cn from 'classnames';

const FindSpecialistBtn = ({
  className = '',
  stateAnchor,
  goalTag,
  label = 'Подобрать специалиста',
}: IFindSpecialistBtnProps): ReactElement => {
  const { user } = useAuthContext();
  const userId = user?.userId;

  const onHandleClick = (goalTag: string) => {
    // @ts-ignore
    ym(97788822, 'reachGoal', goalTag, {
      isAuthorize: !!user,
      userId: userId ?? null,
    });
  };

  return (
    <Link
      to={userId ? RoutePath.SPECIALISTS : RoutePath.REACT_ANKETA}
      state={{ anchor: stateAnchor, actionTab: '2', goalTag }}
      className={cn(styles.root, className)}
      onClick={() => onHandleClick(goalTag)}
    >
      {label}
    </Link>
  );
};

export default FindSpecialistBtn;
